import { ERP } from '../_base/endpoint';
import axios from 'axios';

class tipoMovimientoService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}logistica/tipo-movimiento`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new tipoMovimientoService();